<template>
  <RouterLink :to="`/catalog-menu/${data.id}`" class="catalog-item">
    <div class="catalog-item__left">
      <div class="catalog-item__icon">
        <svg width="20" height="20">
          <use :xlink:href="iconPath"></use>
        </svg>
      </div>
      {{ data.name }}
    </div>
    <svg width="20" height="20">
      <use xlink:href="@/assets/icons/sprite.svg#caretUp"></use>
    </svg>
  </RouterLink>
</template>
<script setup lang="ts">
  import { computed } from "vue";
  import sprite from "@/assets/icons/sprite.svg";

  const props = defineProps(["data"]);
 
  const iconPath = computed(() => `${sprite}#${props.data.ufIcon}`);

</script>
<style lang="scss">
  .catalog-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $almostBlack;

    &__icon {
      flex: 0 0 auto;
      margin-right: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      width: 40px;
      height: 40px;
      background-color: $lightGreen;
    }

    &__left {
      display: flex;
      align-items: center;
    }
  }
</style>
